module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/208-palestine-bceff627cb19989b6507e4452e6de3d7.svg";